<!-- src/components/yuyue/modals/UserEditModal.vue -->
<template>
  <div class="modal" :class="{ active: isVisible }">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">编辑用户</h3>
        <button class="close-modal" @click="closeModal">&times;</button>
      </div>
      
      <form v-if="user" @submit.prevent="submitForm">
        <div class="form-group">
          <label>姓名</label>
          <input type="text" v-model="form.name" required />
        </div>
        
        <div class="form-group">
          <label>邮箱</label>
          <input type="email" v-model="form.email" required />
        </div>
        
        <div class="form-group">
          <label>角色</label>
          <select v-model="form.role" required>
            <option value="admin">管理员</option>
            <option value="teacher">教师</option>
            <option value="parent">家长</option>
          </select>
        </div>
        
        <div class="form-group">
          <label>联系电话</label>
          <input type="text" v-model="form.phone" />
        </div>
        
        <div class="form-group">
          <label>状态</label>
          <select v-model="form.status">
            <option value="active">启用</option>
            <option value="inactive">禁用</option>
          </select>
        </div>
        
        <div class="form-actions">
          <button type="button" class="btn btn-secondary" @click="closeModal">取消</button>
          <button type="submit" class="btn btn-primary">保存更改</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserEditModal',
  data() {
    return {
      isVisible: false,
      user: null,
      form: {
        name: '',
        email: '',
        role: '',
        phone: '',
        status: 'active'
      }
    }
  },
  methods: {
    show(user) {
      this.user = user;
      this.form = { ...user };
      this.isVisible = true;
    },
    closeModal() {
      this.isVisible = false;
      this.user = null;
    },
    submitForm() {
      // Emit event with updated user data
      this.$emit('update-user', { 
        id: this.user.id, 
        ...this.form 
      });
      this.closeModal();
    }
  }
}
</script>

<style scoped>
/* Styles are inherited from parent component */
</style>